export default function ContactMapVisual() {
  return (
    <svg viewBox="0 0 320 240" fill="none" xmlns="http://www.w3.org/2000/svg" className="contact-map-svg">
      <rect width="320" height="240" rx="16" fill="#e0f2fe" />
      <path
        d="M40 180 Q80 120 120 140 T200 100 T280 130"
        stroke="#0ea5e9"
        strokeWidth="3"
        strokeDasharray="8 8"
        fill="none"
        opacity="0.5"
      />
      <circle cx="160" cy="120" r="48" fill="rgba(14,165,233,0.15)" stroke="#0ea5e9" strokeWidth="2" />
      <path
        d="M160 88c14 0 25 11 25 25 0 18-25 42-25 42s-25-24-25-42c0-14 11-25 25-25z"
        fill="#0ea5e9"
      />
      <circle cx="160" cy="113" r="8" fill="#fff" />
      <text x="160" y="200" textAnchor="middle" fill="#0b1f3a" fontSize="14" fontWeight="700" fontFamily="system-ui">
        Jaipur, Rajasthan
      </text>
      <text x="160" y="218" textAnchor="middle" fill="#64748b" fontSize="11" fontFamily="system-ui">
        India
      </text>
    </svg>
  );
}
